@if (message.title) {
  <h2 mat-dialog-title>
    {{message.title}}
  </h2>
}
<mat-dialog-content cdkFocusInitial>
  <div class="dialog-content">
    <span class="material-symbols-rounded" [class]="message.type">{{getIconByMessageType()}}</span>
    <div>
      <div class="text" [innerHTML]="modalMessage">
      </div>
      <div class="additional-info" innerHTML="{{message.info}}">
        <!-- {{message.info}} -->
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @for (button of message.buttons; track button; let i = $index) {
    <button mat-raised-button mat-dialog-close
      [color]="getButtonColor(i, button)"
      (click)="close(button)"
    [style.background-color]="getButtonBgColor(i, button)">{{getButtonText(i, button)}}</button>
    <!--<button mat-raised-button color="primary" mat-dialog-close *ngSwitchCase="'ok'" (click)="close(button)">{{'UI.Label.OK|OK' | translate}}</button>
    <button mat-raised-button color="accent" mat-dialog-close *ngSwitchCase="'no'" (click)="close(button)">{{'UI.Label.No|Nem' | translate}}</button>
    <button mat-raised-button color="primary" mat-dialog-close *ngSwitchCase="'yes'" (click)="close(button)">{{'UI.Label.Yes|Igen' | translate}}</button>
    <button mat-raised-button color="accent" mat-dialog-close *ngSwitchCase="'delete'" (click)="close(button)">{{'UI.Label.Delete|Törlés' | translate}}</button>
    <button mat-raised-button color="accent" mat-dialog-close *ngSwitchCase="'close'" (click)="close(button)">{{'UI.Label.Close|Bezár' | translate}}</button>-->
  }
  @if (message.footerInfo && message.footerInfo.length > 0) {
    <div class="footer-info">
      {{message.footerInfo}}
    </div>
  }
</mat-dialog-actions>
